var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCameraMonitor(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.00001 4.33334C1.97497 4.33334 0.333344 5.97497 0.333344 8.00001V24C0.333344 26.0251 1.97497 27.6667 4.00001 27.6667H18.6667C20.6917 27.6667 22.3333 26.0251 22.3333 24V20.1832L31.6667 24.1832V7.8168L22.3333 11.8168V8.00001C22.3333 5.97497 20.6917 4.33334 18.6667 4.33334H4.00001ZM2.33334 8.00001C2.33334 7.07954 3.07954 6.33334 4.00001 6.33334H18.6667C19.5872 6.33334 20.3333 7.07954 20.3333 8.00001V24C20.3333 24.9205 19.5872 25.6667 18.6667 25.6667H4.00001C3.07954 25.6667 2.33334 24.9205 2.33334 24V8.00001ZM22.3333 13.9927V18.0073L29.6667 21.1501V10.8499L22.3333 13.9927Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCameraMonitor);
export default __webpack_public_path__ + "static/media/cameraMonitor.730033f34a93db85bb2663dc6e815f64.svg";
export { ForwardRef as ReactComponent };